import i18nFactory from '@yandex-int/i18n';
import classNames from 'classnames';
import { CheckBox } from 'lego-on-react';
import * as React from 'react';

import { Bem } from '../../service/Bem/Bem';
import { Shape2, Shape2Icon } from '../Shape2/Shape2';

import './OutdoorRegionHeader.css';
import * as keyset from './OutdoorRegionHeader.i18n';

const i18n = i18nFactory(keyset);

export interface OutdoorRegionHeaderProps {
    checked: boolean;
    totalCount: number;
    selectedCount: number;
    regionText: string;
    regionId: string;
    isOpen: boolean;
    foundCount: number;
    search: {
        value: string;
        test: RegExp;
        match: RegExp;
    };
    onArrowClick: (data: { regionId: string; isOpen: boolean }) => void;
    onCheckBoxChange: (data: { regionId: string; checked: boolean }) => void;
}

export class OutdoorRegionHeader extends React.Component<
    OutdoorRegionHeaderProps
> {
    private block = 'outdoor-region-header';

    render() {
        const { checked, regionText, isOpen } = this.props;

        return (
            <div
                className={Bem.cls({
                    block: this.block,
                    mods: { open: isOpen ? 'yes' : '' }
                })}
                onClick={() => ({})}
            >
                <CheckBox
                    cls={classNames(
                        Bem.cls(this.block, 'checkbox'),
                        Bem.cls('checkbox', '', { outdoor: 'yes' })
                    )}
                    size="n"
                    theme="normal"
                    tone="default"
                    view="default"
                    text={regionText}
                    checked={checked}
                    lines="one"
                    onChange={this.onCheckBoxChange}
                />
                <div
                    className={Bem.cls(this.block, 'head-container')}
                    onClick={this.onArrowClick}
                >
                    {this.getTitle()}
                    <Shape2
                        cls={Bem.cls(this.block, 'icon')}
                        width={12}
                        height={12}
                        icon={Shape2Icon.verticalArrow}
                    />
                </div>
            </div>
        );
    }

    private getTitle = () => {
        const { selectedCount, totalCount, foundCount, search } = this.props;

        return (
            <div className={Bem.cls(this.block, 'head')}>
                <div className={Bem.cls(this.block, 'selected')}>
                    {`${search.value ? i18n('found') : i18n('selected')} ${
                        search.value ? foundCount : selectedCount
                    }`}
                </div>
                <div className={Bem.cls(this.block, 'total')}>
                    {`${i18n('of')} ${totalCount}`}
                </div>
            </div>
        );
    };

    private onCheckBoxChange = () => {
        const { onCheckBoxChange, checked, regionId } = this.props;

        onCheckBoxChange({
            checked: !checked,
            regionId: regionId
        });
    };

    private onArrowClick = () => {
        const { onArrowClick, regionId, isOpen } = this.props;

        onArrowClick({
            isOpen: !isOpen,
            regionId
        });
    };
}
